import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RulesStores } from '../stores';
import { STORE_RULES_IMPORT, STORE_RULES_IMPORT_RESOLUTION } from '../constants';
import type { RuleImportOrigin } from '../types';
import RulesImportModal from '../components/RulesImportModal';

type Props = {
    warningMsg?: string;
    origin: RuleImportOrigin;
} & RulesStores;

const RulesImportDialog: React.FC<Props> = ({ RulesImportUI, RulesImportResolutionUI, origin, warningMsg }) => {
    if (!RulesImportUI || !RulesImportResolutionUI) {
        return null;
    }

    return (
        <RulesImportModal
            store={RulesImportUI}
            resolution={RulesImportResolutionUI}
            origin={origin}
            warningMsg={warningMsg}
        />
    );
};

export default inject(STORE_RULES_IMPORT, STORE_RULES_IMPORT_RESOLUTION)(observer(RulesImportDialog));
